<template>
  <div class="default-layout">
    <client-only>
      <lazy-reflink-banner />
      <lazy-common-notifications
        class="fixed top-0 right-0 z-1056 w-full max-w-148 mt-(--mobile-bar-height) xl:mt-0 px-4 md:px-8"
      />
    </client-only>

    <header>
      <navigation-mobile-bar
        class="fixed top-0 w-full"
        @toggle-mobile-navigation="isMobileMenuOpen = true"
      />
      <navigation-sidebar
        :is-opened="isMobileMenuOpen"
        @update:is-opened="(val) => (isMobileMenuOpen = val)"
      />
    </header>

    <!-- Content area -->
    <div
      class="mt-(--mobile-bar-height) xl:mt-0 xl:ml-(--sidebar-width) xl:w-[calc(100%-var(--sidebar-width))]"
    >
      <slot></slot>
    </div>

    <!-- Footer area -->
    <div
      class="mt-4 md:mt-8 xl:ml-(--sidebar-width) xl:w-[calc(100%-var(--sidebar-width))] border-t border-white/5"
    >
      <footer-the-page-footer class="max-w-7xl mx-auto px-4" />
    </div>

    <lazy-admin-bar v-if="customerIsAdmin" />
    <lazy-navigation-sidebar-user-modal
      v-if="isAuthenticated && hasActiveCustomer"
      :is-modal-open="isUserModalOpen"
      @modal-hidden="isUserModalOpen = false"
    />
  </div>
</template>

<script setup lang="ts">
import { OPEN_MODAL_SYMBOL } from '~/components/navigation/symbols';

const authStore = useAuthStore();
const customerIsAdmin = computed(() => {
  const activeCustomer = authStore.activeCustomer;
  if (activeCustomer == null) return false;
  return activeCustomer.isAdmin;
});

const isAuthenticated = computed(() => authStore.isAuthenticated);

const hasActiveCustomer = computed(() => authStore.activeCustomer != null);

useEmailConfirm();
useNewsletterNotification();

const isMobileMenuOpen = ref(false);
const isUserModalOpen = ref(false);
provide(OPEN_MODAL_SYMBOL, isUserModalOpen);
</script>
